<template>
  <div class="attachments-info">
    <b-row>
      <b-col
        v-if="attachments.length"
        class="mt-2"
      >
        <request-downloadable-attachment
          :attachments="attachments"
          :request-id="request.id"
          :lab-id="request.laboratory.labId"
          :is-formalized="isRequestFormalized"
          :user-have-attach-operation="userHaveAttachOperation"
          @deleteAttachment="onDeleteAttachment"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import RequestDownloadableAttachment from '@/modules/clinicalModule/components/RequestDownloadableAttachment'
import { REQUEST_STATES } from '@/api/resources/entityState/request-state'
import requestAttachmentService from '@/api/resources/attachment/requestAttachmentService'
import { RequestOperation } from '@/api/operations/models/request-operation'
export default {
    name: 'RequestAttachmentsInfo',
    components: {
        RequestDownloadableAttachment
    },
    props: {
        request: { type: Object, required: true }
    },
    data() {
        return {
            attachments: []
        }
    },
    computed: {
        isRequestFormalized() {
            return !(!this.request.status || this.request.status.code === REQUEST_STATES.DRAFT.code)
        },
        userHaveAttachOperation() {
            return !!(this.hasLabOperationGlobalMixin(this.request.laboratory.labId, RequestOperation.ATTACH))
        }
    },
    async created() {
        const [err, response] = await this.toCall(requestAttachmentService.getAttachments(this.request.laboratory.labId, this.request.id))
        if (err) {
            this.showErrorModalGlobal()
            return
        }
        this.attachments = response
    },
    methods: {
        onDeleteAttachment(removedAttachmentId) {
            this.attachments.forEach((attachment, index, attachments) => {
                if (attachment.attachmentId === removedAttachmentId) {
                    attachments.splice(index, 1)
                }
            })
            this.$emit('onDeleteAttachment')
        }
    }
}

</script>
